export const QUADRANTS = {
  now:   { label: 'Do now',   priority: 'urgent' },
  sched: { label: 'Schedule', priority: 'high' },
  del:   { label: 'Delegate', priority: 'medium' },
  later: { label: 'Later',    priority: 'low' },
};

export function quadrantOf(task, meId) {
  const p = task?.priority;
  if (p === 'urgent') return 'now';
  if (p === 'high') return 'sched';
  if (p === 'low') return 'later';
  const who = task?.assignee_id || task?.assigned_to;
  if (who && who !== meId) return 'del';
  return null;
}

export function priorityFor(q) {
  return q && QUADRANTS[q] ? QUADRANTS[q].priority : 'medium';
}
